module.exports = __webpack_public_path__ + "static/Gilroy-Bold-033454e1d410fb5dd437ae5a326e6f56.eot";